import { BrowserRouter, Routes, Route } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Toaster } from "react-hot-toast";


  
import ErrorPage from "./components/ErrorPage";
import Login from "./components/Login";
import MainLayout from "./layout/MainLayout";
import Main from "./pages/Main";
import Attendance from "./pages/Attendance";
import Leave from "./pages/Leaves";
import Offer from './pages/Offer';
import ManagementDesk from './pages/ManagementDesk';
import Career from './pages/Career';
import Birthday from './pages/Birthday';
import Awards from './pages/Awards';
import Contacts from './pages/Contacts';
import Payslip from './pages/Payslip';
import Request from './pages/Request';
import Feedback from './pages/Feedback';
import About from './pages/About';
import MyPerformance from "./pages/MyPerformance";
import Incentives from "./pages/Incentives";
import ForgetPassword from "./pages/ForgetPassword";
import MainAlter from "./pages/mainAlter";


function App() {
  return (
    
    <BrowserRouter>
    <Toaster position="top-center" />
    
      <Routes>


        {/* Error Page */}
        <Route path="*" element={<ErrorPage />} />
        {/* Login */}
        <Route path="/" element={<Login />} />
        
        <Route path="/forgetpassword" element={<ForgetPassword />} />

        {/* Layout Wrapper */}
        <Route path="/dashboard" element={<MainLayout />}>

          {/* Default page */}
          <Route index element={<MainAlter />} />

          {/* Pages */}
          <Route path="main" element={<Main />} />
          <Route path="about" element={<About />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="leave" element={<Leave />} />
          <Route path="offers" element={<Offer />} />
          <Route path="management" element={<ManagementDesk />} />
          <Route path="careers" element={<Career />} />
          <Route path="birthday" element={<Birthday />} />
          <Route path="awards" element={<Awards />} />
          <Route path="contacts" element={<Contacts />} />
          <Route path="Payslip" element={<Payslip />} />
          <Route path="request" element={<Request />} />
          <Route path="feedback" element={<Feedback />} />


          <Route path="myperform" element={<MyPerformance />} />
          <Route path="incentive" element={<Incentives />} />

        </Route>

      </Routes>
    </BrowserRouter>
  );
}

export default App;
